import { forwardRef, HTMLProps } from 'react'
import clsx from 'clsx'

type InputProps = HTMLProps<HTMLInputElement>

const ReceiptSearchInput = forwardRef<HTMLInputElement, InputProps>(
  ({ className, placeholder = 'Filter', ...rest }, ref) => (
    <input
      className={className}
      type="text"
      placeholder={placeholder}
      ref={ref}
      {...rest}
    />
  )
)

export default ReceiptSearchInput
